import { FC, ReactNode, useContext } from 'react';
import MuiMenuItem from '@mui/material/MenuItem';
import { ListItemIcon, Stack } from '@mui/material';
import Icon from '../icon';
import Text from '../text';
import { MenuCloseContext } from '@/contexts/menu/helpers';
import { IconColor, IconType } from '../icon/helpers';

interface Props {
  label: ReactNode;
  subtitle?: string;
  icon?: IconType;
  color?: IconColor;
  disabled?: boolean;
  onClick: () => void;
}

const MenuItem: FC<Props> = ({ label, subtitle, onClick, icon, color, disabled }) => {
  const hasIcon = !!icon;
  const compColor = disabled ? 'grey' : color;
  const onClose = useContext(MenuCloseContext);
  const handleClick = () => {
    onClick();
    onClose?.();
  };

  return (
    <MuiMenuItem onClick={handleClick} disabled={disabled}>
      {hasIcon && (
        <ListItemIcon>
          <Icon name={icon} size="small" color={compColor} />
        </ListItemIcon>
      )}
      <Stack width="100%">
        <Text size="small" color={compColor}>
          {label}
        </Text>
        {subtitle && (
          <Text size="small" color="grey">
            {subtitle}
          </Text>
        )}
      </Stack>
    </MuiMenuItem>
  );
};

export default MenuItem;
